import { render, staticRenderFns } from "./InviteParticipantsModal.vue?vue&type=template&id=223f38f4&scoped=true&"
import script from "./InviteParticipantsModal.vue?vue&type=script&lang=js&"
export * from "./InviteParticipantsModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteParticipantsModal.vue?vue&type=style&index=0&id=223f38f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f38f4",
  null
  
)

export default component.exports